document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelectorAll('#contact-map').length > 0) {
        let coordinates = '';
        const request = BX.ajax.runComponentAction('utlab:geo', 'coordinates', {
            method: 'GET',
            mode: 'class',
            data: {
                SITE_ID: 's1',
                sessid: BX.message('bitrix_sessid')
            }
        });
        request.then(function (response) {
            coordinates = response.data.split(',').map(el => el.trim());
            if (coordinates.length > 0) {
                ymaps.ready(init);
            }
        })

        function init() {
            let myMap = new ymaps.Map("contact-map", {
                center: coordinates,
                zoom: 14
            }, {
                searchControlProvider: 'yandex#search'
            });

            myMap.geoObjects
                .add(new ymaps.Placemark(coordinates, {}, {
                    preset: 'islands#icon',
                    iconColor: '#0095b6'
                }));
        }
    }
});